import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { EMPREENDIMENTO_LANCAMENTO } from '~/constant';
import {
    verificarTemMesa, incluirNumeroMesa, buscarEmpreendimentoLancamento, definirDisponivel, buscarCorretoresLancamento, buscarAtendimentoAtual, validarSenhaTrocaCorretor, trocarCorretorAtendimento, iniciarAtendimento, finalizarAtendimentoColaborador, finalizarComoVisitaLoteamento, buscarMotivosNaoCompra, gravarPesquisaNaoCompra, buscarClienteLancamento, NotificarDepartamentoSemAtendimento, verificarPeriodoLancamento, verificarVinculoProspecto
} from '~/Services/Service';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';
import { FaRegBell, FaPencilAlt, FaBuilding, FaSignInAlt, FaExclamationTriangle, FaMapMarkedAlt, FaFileAlt, FaGem } from 'react-icons/fa';
import NivelBadge from '~/Components/Lancamento/Encaminhamento/NivelBadge';

const formatarData = (data) => {
    if (!data) return '';
    const d = new Date(data);
    if (isNaN(d)) return data;
    return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
};

const DefinirMesaEAtendimento = () => {
    const optionsCarregado = useSelector(state => state.options.optionsCarregado);
    const [numeroMesa, setNumeroMesa] = useState('');
    const [codigoMesa, setCodigoMesa] = useState(null);
    const [mesaConfirmada, setMesaConfirmada] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingInicial, setLoadingInicial] = useState(true);
    const [empreendimentoNome, setEmpreendimentoNome] = useState('');
    const [dentroDoPeridoLancamento, setDentroDoPeridoLancamento] = useState(null);
    const [mensagemForaPeriodo, setMensagemForaPeriodo] = useState('');
    const [buscaProspecto, setBuscaProspecto] = useState('');
    const [loadingBusca, setLoadingBusca] = useState(false);
    const [corretores, setCorretores] = useState([]);
    const [corretorSelecionado, setCorretorSelecionado] = useState(null);
    const [nomeCorretor, setNomeCorretor] = useState('');
    const [ddlCorretorEnabled, setDdlCorretorEnabled] = useState(false);
    const [showEstouDisponivel, setShowEstouDisponivel] = useState(false);
    const [showLiberarTroca, setShowLiberarTroca] = useState(false);
    const [showProspecto, setShowProspecto] = useState(false);
    const [showAtendimento, setShowAtendimento] = useState(false);
    const [showPesquisa, setShowPesquisa] = useState(false);
    const [chamarDiamante, setChamarDiamante] = useState(true);
    const [prospecto, setProspecto] = useState({
        codigo: null,
        nome: '',
        cpf: '',
        dataEmissao: '',
        senha: null,
        atendimentoPreferencial: null,
        codigoCorretor: null,
        nomeCorretor: '',
        flagCorretor: 'P' // P=Próprio, C=Compensação
    });
    const [atendimento, setAtendimento] = useState({
        codigo: null,
        codigo_prospecto: null,
        nome_prospecto: '',
        data_inicio: '',
        status: '',
        proposta: '',
        pre_venda: '',
        tem_reservas: false,
        reservas: [],
        instrucao: '',
        pode_finalizar_direto: true,
        mostrar_pesquisa: true
    });

    const [senhaLiberacao, setSenhaLiberacao] = useState('');
    const [justificativaTroca, setJustificativaTroca] = useState('');
    const [corretorAnterior, setCorretorAnterior] = useState(null);
    const [nomeCorretorAnterior, setNomeCorretorAnterior] = useState('');
    const [usuarioAutorizouTroca, setUsuarioAutorizouTroca] = useState(null);
    const [motivos, setMotivos] = useState([]);
    const [motivosSelecionados, setMotivosSelecionados] = useState([]);
    const [subMotivosValores, setSubMotivosValores] = useState({});
    const [observacoesPesquisa, setObservacoesPesquisa] = useState('');
    const [atendimentoAleatorio, setAtendimentoAleatorio] = useState(false);
    const [trocaCorretorRealizada, setTrocaCorretorRealizada] = useState(false);
    const [removerReservas, setRemoverReservas] = useState(true);
    const [mesaDisponivel, setMesaDisponivel] = useState(false);
    const inputProspectoRef = useRef(null);
    const [showModalIniciar, setShowModalIniciar] = useState(false);
    const [showModalFinalizar, setShowModalFinalizar] = useState(false);
    const [showModalVisitar, setShowModalVisitar] = useState(false);
    const [showModalPesquisa, setShowModalPesquisa] = useState(false);

    const buscarEmpreendimento = async () => {
        try {
            const resposta = await buscarEmpreendimentoLancamento(EMPREENDIMENTO_LANCAMENTO);
            if (resposta && resposta.codigo_familia && resposta.descricao) {
                return resposta.codigo_familia + ' - ' + resposta.descricao;
            }
            return EMPREENDIMENTO_LANCAMENTO.toString();
        } catch (error) {
            console.error('Erro ao buscar família do empreendimento:', error);
            return EMPREENDIMENTO_LANCAMENTO.toString();
        }
    };

    useEffect(() => {
        if (!optionsCarregado || !EMPREENDIMENTO_LANCAMENTO) return;

        const carregarDados = async () => {
            try {
                const respostaPeriodo = await verificarPeriodoLancamento(EMPREENDIMENTO_LANCAMENTO);

                if (respostaPeriodo && respostaPeriodo.dentro_periodo === true) {
                    setDentroDoPeridoLancamento(true);
                    const nomeEmp = await buscarEmpreendimento();
                    setEmpreendimentoNome(nomeEmp);
                    await verificarMesaUsuario();
                } else {
                    setDentroDoPeridoLancamento(false);
                    var mensagem = (respostaPeriodo && respostaPeriodo.mensagem) ? respostaPeriodo.mensagem : 'O período de lançamento não está ativo no momento.';
                    setMensagemForaPeriodo(mensagem);
                    setLoadingInicial(false);
                }
            } catch (error) {
                console.error('Erro ao verificar período de lançamento:', error);
                setDentroDoPeridoLancamento(false);
                setMensagemForaPeriodo('Erro ao verificar período de lançamento. Tente novamente mais tarde.');
                setLoadingInicial(false);
            }
        };
        carregarDados();
    }, [optionsCarregado]);

    useEffect(() => {
        if (mesaConfirmada) {
            const inicializarAtendimento = async () => {
                await carregarCorretores();

                try {
                    const atendimentoAtual = await buscarAtendimentoAtual(EMPREENDIMENTO_LANCAMENTO);

                    if (atendimentoAtual && atendimentoAtual.codigo) {
                        AuthStorage.setAtendimentoAtivo(atendimentoAtual.codigo);
                        setShowAtendimento(true);
                        setAtendimento(atendimentoAtual);
                        setMesaDisponivel(false);
                    } else {
                        AuthStorage.clearAtendimentoAtivo();
                        try {
                            const respostaMesa = await verificarTemMesa(EMPREENDIMENTO_LANCAMENTO);
                            if (respostaMesa && respostaMesa.esperando_senha === true) {
                                setMesaDisponivel(true);
                                setShowEstouDisponivel(false);
                            } else {
                                setMesaDisponivel(false);
                                setShowEstouDisponivel(true);
                            }
                        } catch (error) {
                            console.error('Erro ao verificar status da mesa:', error);
                            setShowEstouDisponivel(true);
                        }
                    }
                } catch (error) {
                    console.error('Erro ao buscar atendimento atual:', error);
                    toast.error('Erro ao buscar atendimento. Tente novamente.');
                    setShowEstouDisponivel(true);
                }

                setTimeout(() => {
                    if (inputProspectoRef.current) {
                        inputProspectoRef.current.focus();
                    }
                }, 100);
            };

            inicializarAtendimento();
        }
    }, [mesaConfirmada]);

    const getMesaDaSessao = () => {
        return AuthStorage.getMesaSessao();
    };

    const salvarMesaNaSessao = (numeroMesa, codigoMesaParam) => {
        AuthStorage.setMesaSessao({
            numeroMesa: numeroMesa,
            codigoMesa: codigoMesaParam,
            timestamp: new Date().getTime(),
        });
    };

    const limparMesaDaSessao = () => {
        AuthStorage.clearMesaSessao();
    };

    const handleRedefinirMesa = () => {
        limparMesaDaSessao();
        setMesaConfirmada(false);
        setNumeroMesa('');
        setCodigoMesa(null);
        setShowEstouDisponivel(false);
        setShowAtendimento(false);
        setShowProspecto(false);
        setShowPesquisa(false);
        setShowLiberarTroca(false);
        setBuscaProspecto('');
        setAtendimento({
            codigo: null,
            codigo_prospecto: null,
            nome_prospecto: '',
            data_inicio: '',
            status: '',
            proposta: '',
            pre_venda: '',
            tem_reservas: false,
            reservas: [],
            instrucao: '',
            pode_finalizar_direto: true,
            mostrar_pesquisa: true
        });

        toast.info('Mesa redefinida. Informe o novo número da mesa.');
    };

    const verificarMesaUsuario = async () => {
        setLoadingInicial(true);
        try {
            const mesaSessao = AuthStorage.getMesaSessao();

            if (mesaSessao && mesaSessao.numeroMesa) {
                setNumeroMesa(mesaSessao.numeroMesa);
                if (mesaSessao.codigoMesa) {
                    setCodigoMesa(mesaSessao.codigoMesa);
                }
                setMesaConfirmada(true);
            } else {
                setMesaConfirmada(false);
            }
        } catch (error) {
            console.error('Erro ao verificar mesa do usuário:', error);
            setMesaConfirmada(false);
        } finally {
            setLoadingInicial(false);
        }
    };

    // ===== FUNÇÕES DE ATENDIMENTO =====

    const carregarCorretores = async () => {
        try {
            const response = await buscarCorretoresLancamento(EMPREENDIMENTO_LANCAMENTO);
            setCorretores(response || []);
        } catch (error) {
            console.error('Erro ao carregar corretores:', error);
            setCorretores([]);
        }
    };

    const carregarAtendimentoAtual = async () => {
        try {
            const response = await buscarAtendimentoAtual(EMPREENDIMENTO_LANCAMENTO);
            if (response && response.codigo) {
                setAtendimento(response);
                setShowAtendimento(true);
                return response;
            }
            return null;
        } catch (error) {
            console.error('Erro ao buscar atendimento:', error);
            return null;
        }
    };

    const handleBuscarProspecto = async () => {
        if (!buscaProspecto.trim()) {
            toast.error('Informe o prospecto, CPF ou senha');
            return;
        }

        if (atendimento.codigo) {
            toast.warning('Não é possível buscar por novos prospectos enquanto há atendimento em andamento');
            setBuscaProspecto('');
            return;
        }

        setLoadingBusca(true);
        try {
            var termo = buscaProspecto.trim();
            var nivel = termo.length <= 4 ? chamarDiamante : null;
            const response = await buscarClienteLancamento(EMPREENDIMENTO_LANCAMENTO, termo, nivel);


            if (response) {
                setProspecto({
                    codigo: response.codigo,
                    nome: response.nome,
                    cpf: response.cpf,
                    dataEmissao: response.data_cadastro,
                    senha: response.senha > 0 ? response.senha : null,
                    atendimentoPreferencial: response.atendimento_preferencial != null ? response.atendimento_preferencial : null,
                    codigoCorretor: response.codigo_corretor,
                    nomeCorretor: response.nome_corretor,
                    flagCorretor: response.flag_corretor || 'P'
                });
                setCorretorSelecionado(response.codigo_corretor);
                setNomeCorretor(response.nome_corretor);
                setShowProspecto(true);
                setBuscaProspecto('');
            } else {
                toast.error('Prospecto não encontrado');
            }
        } catch (error) {
            console.error('Erro ao buscar prospecto:', error);
            const errorMessage = error.message || 'Prospecto não encontrado';
            toast.error(errorMessage);
        } finally {
            setLoadingBusca(false);
        }
    };

    const handleTrocarCorretor = async () => {
        if (!codigoMesa) {
            toast.error('Mesa não identificada');
            return;
        }
        setCorretorAnterior(corretorSelecionado);
        setNomeCorretorAnterior(nomeCorretor);
        setShowLiberarTroca(true);
        try {
            await NotificarDepartamentoSemAtendimento('apoio', codigoMesa);
            toast.info('Um administrador foi chamado, por favor aguarde.');
        } catch (error) {
            console.error('Erro ao notificar departamento:', error);
            toast.error('Erro ao notificar o departamento de apoio');
        }
    };

    const handleLiberarDDLCorretor = async () => {
        if (!justificativaTroca.trim()) {
            toast.error('Por favor, preencha uma justificativa');
            return;
        }

        if (!senhaLiberacao.trim()) {
            toast.error('Por favor, informe a senha de liberação');
            return;
        }

        try {
            const response = await validarSenhaTrocaCorretor(senhaLiberacao);
            if (response && response.valido) {
                setUsuarioAutorizouTroca(response.codigo_usuario_autorizador);
                setDdlCorretorEnabled(true);
                toast.success('Senha validada. Selecione o novo corretor.');
            } else {
                toast.error('Senha inválida');
            }
        } catch (error) {
            console.error('Erro ao validar senha:', error);
            toast.error('Senha inválida');
        }
    };

    const handleConfirmarTroca = async () => {
        if (!corretorSelecionado) {
            toast.error('Selecione um corretor da lista');
            return;
        }

        try {
            const request = {
                codigo_familia: EMPREENDIMENTO_LANCAMENTO,
                codigo_prospecto: prospecto.codigo,
                codigo_corretor_novo: parseInt(corretorSelecionado),
                codigo_gerente_novo: 0,
                codigo_corretor_antigo: corretorAnterior ? parseInt(corretorAnterior) : 0,
                nome_corretor_antigo: nomeCorretorAnterior || '',
                nome_corretor_novo: nomeCorretor,
                justificativa: justificativaTroca,
                codigo_usuario_autorizador: usuarioAutorizouTroca
            };

            await trocarCorretorAtendimento(request);

            setTrocaCorretorRealizada(true);
            setDdlCorretorEnabled(false);
            setShowLiberarTroca(false);
            setSenhaLiberacao('');
            setJustificativaTroca('');
            setProspecto(prev => ({
                ...prev,
                codigoCorretor: corretorSelecionado,
                nomeCorretor: nomeCorretor
            }));

            toast.success('Corretor alterado com sucesso');
        } catch (error) {
            console.error('Erro ao trocar corretor:', error);
            toast.error('Erro ao trocar corretor. Tente novamente.');
        }
    };

    const handleCancelarTroca = () => {
        setCorretorSelecionado(corretorAnterior);
        setNomeCorretor(nomeCorretorAnterior);
        setShowLiberarTroca(false);
        setDdlCorretorEnabled(false);
        setSenhaLiberacao('');
        setJustificativaTroca('');
    };

    const handleEstouDisponivel = async () => {
        try {
            await definirDisponivel(codigoMesa, true);
            setShowEstouDisponivel(false);
            setMesaDisponivel(true);
            toast.success('Sua mesa agora está disponível para atendimento. Por favor, aguarde um cliente chegar à sua mesa.');
        } catch (error) {
            console.error('Erro ao marcar mesa como disponível:', error);
            toast.error('Erro ao marcar mesa como disponível');
        }
    };

    const handleIniciarAtendimento = async () => {
        setShowModalIniciar(false);
        setLoading(true);
        try {
            const vinculo = await verificarVinculoProspecto(EMPREENDIMENTO_LANCAMENTO, prospecto.codigo);
            if (!vinculo || !vinculo.vinculado) {
                toast.error('Este prospecto não possui vínculo com o empreendimento do lançamento');
                setLoading(false);
                return;
            }

            const request = {
                codigo_familia: EMPREENDIMENTO_LANCAMENTO,
                codigo_prospecto: prospecto.codigo,
                codigo_corretor: parseInt(corretorSelecionado),
                codigo_mesa: codigoMesa,
                atendimento_aleatorio: atendimentoAleatorio,
                senha: prospecto.senha || null
            };

            const response = await iniciarAtendimento(request);

            toast.success('Atendimento iniciado com sucesso');
            setShowProspecto(false);
            setBuscaProspecto('');

            if (response && response.codigo_atendimento) {
                AuthStorage.setAtendimentoAtivo(response.codigo_atendimento);
                setAtendimento({
                    codigo: response.codigo_atendimento,
                    codigo_prospecto: prospecto.codigo,
                    nome_prospecto: prospecto.nome + (prospecto.senha ? ' - Senha ' + prospecto.senha : ''),
                    data_inicio: new Date().toLocaleString('pt-BR'),
                    status: 'Em Atendimento',
                    proposta: 'proposta não realizada',
                    pre_venda: 'venda não realizada',
                    tem_reservas: false,
                    reservas: [],
                    instrucao: '',
                    pode_finalizar_direto: true,
                    mostrar_pesquisa: true
                });
                setShowAtendimento(true);
                window.location.href = `/mapa/${EMPREENDIMENTO_LANCAMENTO}?prospecto=${prospecto.codigo}`;

            }
        } catch (error) {
            console.error('Erro ao iniciar atendimento:', error);
            const errorMessage = error.message || 'Erro ao iniciar atendimento';
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizarAtendimento = async (confirmarUsuario = true) => {
        setShowModalFinalizar(false);
        setLoading(true);
        try {
            await finalizarAtendimentoColaborador(atendimento.codigo, removerReservas);
            try {
                await definirDisponivel(codigoMesa, false);
            } catch (e) {
                console.error('Erro ao desativar mesa:', e);
            }
            AuthStorage.clearAtendimentoAtivo();
            toast.success('Atendimento finalizado com sucesso');
            window.location.reload();
        } catch (error) {
            console.error('Erro ao finalizar atendimento:', error);
            const errorMessage = error.message || 'Erro ao finalizar atendimento';
            toast.error(errorMessage);
            setLoading(false);
        }
    };

    const handleVisitarLoteamento = async () => {
        setShowModalVisitar(false);
        setLoading(true);
        try {
            await finalizarComoVisitaLoteamento(atendimento.codigo);
            try {
                await definirDisponivel(codigoMesa, false);
            } catch (e) {
                console.error('Erro ao desativar mesa:', e);
            }

            AuthStorage.clearAtendimentoAtivo();
            toast.success('Atendimento finalizado como visita ao loteamento');
            window.location.reload();
        } catch (error) {
            console.error('Erro ao finalizar como visita:', error);
            const errorMessage = error.message || 'Erro ao finalizar como visita ao loteamento';
            toast.error(errorMessage);
            setLoading(false);
        }
    };

    const handlePesquisaNaoCompra = async () => {
        setShowPesquisa(true);
        setShowAtendimento(false);
        try {
            const response = await buscarMotivosNaoCompra();
            setMotivos(response || []);
        } catch (error) {
            console.error('Erro ao carregar motivos:', error);
            setMotivos([]);
        }
    };

    const handleCancelarPesquisa = () => {
        setShowPesquisa(false);
        setShowAtendimento(true);
        setMotivosSelecionados([]);
        setSubMotivosValores({});
        setObservacoesPesquisa('');
    };

    const handleAbrirModalPesquisa = () => {
        if (motivosSelecionados.length === 0) {
            toast.error('Selecione pelo menos um motivo para completar a pesquisa');
            return;
        }
        setShowModalPesquisa(true);
    };

    const handleGravarPesquisa = async () => {
        setShowModalPesquisa(false);
        setLoading(true);
        try {
            const motivosRequest = motivosSelecionados.map(codigoMotivo => {
                const motivo = motivos.find(m => m.codigo === codigoMotivo);
                let subMotivoSelecionado = null;
                let descricaoSubMotivo = '';

                if (motivo && motivo.sub_motivos && motivo.sub_motivos.length > 0) {
                    for (const sub of motivo.sub_motivos) {
                        if (subMotivosValores[sub.codigo]) {
                            subMotivoSelecionado = sub.codigo;
                            descricaoSubMotivo = subMotivosValores[sub.codigo];
                            break;
                        }
                    }
                }

                return {
                    codigo_motivo: codigoMotivo,
                    codigo_sub_motivo: subMotivoSelecionado,
                    descricao: descricaoSubMotivo
                };
            });

            const request = {
                motivos: motivosRequest,
                observacoes: observacoesPesquisa
            };

            await gravarPesquisaNaoCompra(atendimento.codigo, request);
            try {
                await definirDisponivel(codigoMesa, false);
            } catch (e) {
                console.error('Erro ao desativar mesa:', e);
            }

            AuthStorage.clearAtendimentoAtivo();
            toast.success('Pesquisa gravada e atendimento finalizado com sucesso');

            window.location.reload();
        } catch (error) {
            console.error('Erro ao gravar pesquisa:', error);
            const errorMessage = error.message || 'Erro ao gravar pesquisa';
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleMapaHumanizado = () => {
        toast.info('Você será redirecionado para o mapa do empreendimento');
        const codigoProspecto = atendimento.codigo_prospecto || prospecto.codigo;
        const url = codigoProspecto
            ? `/mapa/${EMPREENDIMENTO_LANCAMENTO}?prospecto=${codigoProspecto}`
            : `/mapa/${EMPREENDIMENTO_LANCAMENTO}`;
        window.location.href = url;
    };

    const toggleMotivo = (codigoMotivo) => {
        if (motivosSelecionados.includes(codigoMotivo)) {
            setMotivosSelecionados(motivosSelecionados.filter(m => m !== codigoMotivo));
        } else {
            setMotivosSelecionados([...motivosSelecionados, codigoMotivo]);
        }
    };

    const handleSubMotivoChange = (codigoSubMotivo, valor) => {
        setSubMotivosValores({
            ...subMotivosValores,
            [codigoSubMotivo]: valor
        });
    };

    const handleConfirmarMesa = async () => {
        if (!numeroMesa) {
            toast.error('Informe o número da mesa');
            return;
        }

        setLoading(true);
        try {
            const respostaMesa = await verificarTemMesa(EMPREENDIMENTO_LANCAMENTO);

            if (!respostaMesa || !respostaMesa.codigo) {
                toast.error('Usuário não possui mesa configurada');
                setLoading(false);
                return;
            }

            const codigoMesaRetornado = respostaMesa.codigo;

            await incluirNumeroMesa(
                EMPREENDIMENTO_LANCAMENTO,
                codigoMesaRetornado,
                parseInt(numeroMesa)
            );

            setCodigoMesa(codigoMesaRetornado);
            salvarMesaNaSessao(numeroMesa, codigoMesaRetornado);
            setMesaConfirmada(true);
            toast.success(`Mesa ${numeroMesa} confirmada com sucesso`);
        } catch (error) {
            console.error('Erro ao confirmar mesa:', error);
            const errorMessage = (error.response && error.response.data)
                || error.message
                || 'Erro ao confirmar mesa';
            toast.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    if (loadingInicial) {
        return (
            <div
                className="container-fluid bg-light p-3"
                style={{ minHeight: '100vh' }}
            >
                <div className="lotes-header py-3 mb-3">
                    <div className="d-flex align-items-center justify-content-between px-3">
                        <h4 className="lotes-header__title mb-0">Atendimento</h4>
                    </div>
                </div>
                <div className="bg-white rounded my-2 shadow-sm border">
                    <div className="p-5 text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Carregando...</span>
                        </div>
                        <p className="mt-3 text-muted">Verificando mesa do usuário...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (dentroDoPeridoLancamento === false) {
        return (
            <div
                className="container-fluid bg-light p-3"
                style={{ minHeight: '100vh' }}
            >
                <div className="lotes-header py-3 mb-3">
                    <div className="d-flex align-items-center justify-content-between px-3">
                        <h4 className="lotes-header__title mb-0">Atendimento</h4>
                    </div>
                </div>
                <div className="bg-white rounded my-2 shadow-sm border">
                    <div className="p-5 text-center">
                        <FaExclamationTriangle size={48} className="text-warning mb-3" />
                        <h5 className="text-danger">Acesso Indisponível</h5>
                        <p className="text-muted">{mensagemForaPeriodo}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div
            className="container-fluid bg-light p-3"
            style={{ minHeight: '100vh' }}
        >
            <div className="lotes-header py-3 mb-3">
                <div className="d-flex align-items-center justify-content-between px-3">
                    <h4 className="lotes-header__title mb-0">Atendimento</h4>
                    <div className="d-flex align-items-center">
                        <div className="mr-2">
                            <div style={{ minWidth: '400px', maxWidth: '600px' }}>
                                <div
                                    className="d-flex align-items-center justify-content-between px-3 py-2 rounded"
                                    style={{
                                        backgroundColor: '#f8f9fa',
                                        border: '1px solid #ced4da',
                                        minHeight: '38px',
                                    }}
                                >
                                    <span className="text-dark">
                                        {mesaConfirmada ? `Mesa ${numeroMesa}` : empreendimentoNome || 'Carregando...'}
                                    </span>
                                    {mesaConfirmada && (
                                        <Button
                                            variant="outline-success"
                                            size="sm"
                                            onClick={handleRedefinirMesa}
                                            className="ml-2 "
                                            title={atendimento.codigo ? "Finalize o atendimento para alterar a mesa" : "Redefinir número da mesa"}
                                            disabled={!!atendimento.codigo}
                                        >
                                            Alterar Mesa <FaPencilAlt className="ml-1 mb-1" />
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!mesaConfirmada ? (
                <div className="card shadow-sm my-2">
                    <div className="card-body text-center py-4">
                        <div className="text-success fw-semibold mb-3">
                            Informe o número da sua mesa
                        </div>

                        <div className="d-flex flex-column align-items-center">
                            <input
                                id="mesa"
                                type="number"
                                className="form-control text-center fw-bold border-2 px-0"
                                style={{ width: "100px", height: "70px", fontSize: "34px" }}
                                value={numeroMesa}
                                onChange={(e) => {
                                    const valor = e.target.value;
                                    if (
                                        valor === "" ||
                                        (/^\d{1,3}$/.test(valor) && Number(valor) > 0)
                                    ) {
                                        setNumeroMesa(valor);
                                    }
                                }}
                                disabled={loading}
                            />

                            <Button
                                variant="success"
                                className="mt-3 px-4 text-uppercase"
                                onClick={handleConfirmarMesa}
                                disabled={loading || !numeroMesa}
                            >
                                {loading ? "Confirmando..." : "Confirmar"}
                            </Button>
                        </div>
                    </div>
                </div>

            ) : (
                <>
                    {/* HEADER DE BUSCA */}
                    {!showAtendimento && <div className="bg-white rounded my-2 shadow-sm border">
                        <div className="p-3">
                            <h5>Selecione o cliente e o corretor para realizar um atendimento</h5>
                            <div className="row">
                                {/* Toggle Nível */}
                                <div className="col-md-1 d-flex flex-column align-items-center justify-content-end mb-3">
                                    <Form.Check
                                        type="switch"
                                        id="toggle-nivel-mesa"
                                        checked={chamarDiamante}
                                        onChange={() => setChamarDiamante(!chamarDiamante)}
                                        label=""
                                        className="mb-1"
                                    />
                                    <small
                                        className="font-weight-bold"
                                        style={{ color: chamarDiamante ? '#1565C0' : '#FF8F00', fontSize: '0.75rem' }}
                                    >
                                        {chamarDiamante ? 'Diamante' : 'Topázio'}
                                    </small>
                                </div>
                                {/* Input Busca Prospecto */}
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Informe o Prospecto / Cpf / Senha</label>
                                        <div className="input-group">
                                            <input
                                                ref={inputProspectoRef}
                                                className="form-control"
                                                placeholder="Prospecto / Cpf / Senha"
                                                value={buscaProspecto}
                                                onChange={(e) => setBuscaProspecto(e.target.value)}
                                                disabled={!!atendimento.codigo || loadingBusca}
                                            />
                                            <div className="input-group-append">
                                                <Button
                                                    variant="success"
                                                    onClick={handleBuscarProspecto}
                                                    disabled={loadingBusca || !!atendimento.codigo || !buscaProspecto}
                                                >
                                                    {loadingBusca ? 'Buscando...' : 'OK'}
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Dropdown Corretor */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Informe o Corretor</label>
                                        <div className="d-flex">
                                            <div style={{ flex: 1 }}>
                                                <Select
                                                    placeholder="Selecione um corretor"
                                                    noOptionsMessage={() => 'Nenhum corretor encontrado'}
                                                    options={corretores.map(c => ({
                                                        value: c.codigo,
                                                        label: c.codigo + ' - ' + c.descricao
                                                    }))}
                                                    value={
                                                        corretorSelecionado
                                                            ? {
                                                                value: parseInt(corretorSelecionado),
                                                                label: corretores.find(c => c.codigo === parseInt(corretorSelecionado))
                                                                    ? corretores.find(c => c.codigo === parseInt(corretorSelecionado)).codigo + ' - ' + corretores.find(c => c.codigo === parseInt(corretorSelecionado)).descricao
                                                                    : ''
                                                            }
                                                            : null
                                                    }
                                                    onChange={(option) => {
                                                        if (option) {
                                                            setCorretorSelecionado(option.value);
                                                            const corretor = corretores.find(c => c.codigo === option.value);
                                                            if (corretor) setNomeCorretor(corretor.descricao);
                                                        } else {
                                                            setCorretorSelecionado(null);
                                                            setNomeCorretor('');
                                                        }
                                                    }}
                                                    isDisabled={!ddlCorretorEnabled}
                                                    isClearable
                                                    styles={customStyles}
                                                    components={{ DropdownIndicator }}
                                                />
                                            </div>
                                            <div className="ml-1 d-flex">
                                                {!showLiberarTroca ? (
                                                    <Button
                                                        variant="danger"
                                                        onClick={handleTrocarCorretor}
                                                        disabled={!showProspecto}
                                                    >
                                                        Trocar Corretor
                                                    </Button>
                                                ) : (
                                                    <>
                                                        <Button variant="success" onClick={handleConfirmarTroca}>
                                                            OK
                                                        </Button>
                                                        <Button variant="secondary" onClick={handleCancelarTroca}>
                                                            Cancelar
                                                        </Button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}

                    {/* PAINEL ESTOU DISPONÍVEL */}
                    {showEstouDisponivel && !showAtendimento && !showProspecto && !mesaDisponivel && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="p-3">
                                <h5>
                                    <strong>Você não está em atendimento ou aguardando uma senha.</strong>
                                </h5>
                                <p>Clique no botão "Estou Disponível" para que um cliente seja encaminhado a você.</p>
                                <Button
                                    variant="success"
                                    onClick={handleEstouDisponivel}
                                    disabled={loading}
                                >
                                    <i className="fa fa-bullhorn "></i>
                                    {loading ? (
                                        'Processando...'
                                    ) : (
                                        <>
                                            Estou Disponível <FaRegBell />
                                        </>
                                    )}
                                </Button>

                            </div>
                        </div>
                    )}

                    {/* PAINEL MESA DISPONÍVEL - AGUARDANDO CLIENTE */}
                    {mesaDisponivel && !showAtendimento && !showProspecto && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="p-3">
                                <h5>
                                    <strong>Sua mesa está disponível.</strong>
                                </h5>
                                <p>Aguarde um cliente chegar à sua mesa ou busque um prospecto utilizando o campo acima.</p>
                            </div>
                        </div>
                    )}

                    {/* PAINEL LIBERAR TROCA DE CORRETOR */}
                    {showLiberarTroca && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="p-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Senha</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                placeholder="senha de liberação de escolha de corretor"
                                                value={senhaLiberacao}
                                                onChange={(e) => setSenhaLiberacao(e.target.value)}
                                                autoComplete="new-password"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Justificativa</label>
                                            <input
                                                className="form-control"
                                                value={justificativaTroca}
                                                onChange={(e) => setJustificativaTroca(e.target.value)}
                                            />
                                        </div>
                                        <Button variant="danger" onClick={handleLiberarDDLCorretor}>
                                            Liberar
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* PAINEL PROSPECTO ENCONTRADO */}
                    {showProspecto && !showAtendimento && !showPesquisa && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="px-3 py-2 rounded-top" style={{ backgroundColor: '#0747a6' }}>
                                <h6 className="mb-0 text-white">Cliente</h6>
                            </div>
                            <div className="p-3">
                                <div className="row mb-3">
                                    <div className="col-md-1">
                                        <h3>{prospecto.codigo}</h3>
                                    </div>
                                    <div className="col-md-10">
                                        <h3>{prospecto.nome}</h3>
                                    </div>
                                    <div className="col-md-1 d-flex align-items-center">
                                        {prospecto.senha ? (
                                            <NivelBadge isDiamante={prospecto.atendimentoPreferencial} senha={prospecto.senha} />
                                        ) : (
                                            <span className="text-muted">Sem senha</span>
                                        )}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <h5>Data de cadastro: {prospecto.dataEmissao ? new Date(prospecto.dataEmissao).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : ''}</h5>
                                        <h5>CPF: {prospecto.cpf}</h5>
                                    </div>
                                    <div className="col-md-6">
                                        <h5>
                                            Corretor ({prospecto.flagCorretor}): {prospecto.codigoCorretor} - {prospecto.nomeCorretor}
                                        </h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-right">
                                        <Button
                                            variant="success"
                                            onClick={() => setShowModalIniciar(true)}
                                            disabled={loading}
                                        >
                                            Iniciar Atendimento <FaSignInAlt />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* PAINEL ATENDIMENTO ATUAL */}
                    {showAtendimento && !showPesquisa && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="px-3 py-2 rounded-top" style={{ backgroundColor: '#0747a6' }}>
                                <h6 className="mb-0 text-white">Atendimento Atual</h6>
                            </div>
                            <div className="p-3">
                                {/* Dados do Atendimento */}
                                <div className="row mb-3">
                                    <div className="col-md-1">
                                        <h3>{atendimento.codigo_prospecto}</h3>
                                    </div>
                                    <div className="col-md-11">
                                        <h3>{atendimento.nome_prospecto}</h3>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <h5>Data de início: {formatarData(atendimento.data_inicio)}</h5>
                                        <h5>Status: {atendimento.status}</h5>
                                    </div>
                                    <div className="col-md-6">
                                        <h5>Proposta: {atendimento.proposta}</h5>
                                        <h5>Pre Venda: {atendimento.pre_venda}</h5>
                                    </div>
                                </div>

                                {/* Instrução (condicional) */}
                                {atendimento.instrucao && (
                                    <div className="alert alert-warning">
                                        <strong>{atendimento.instrucao}</strong>
                                    </div>
                                )}

                                {/* Grid de Reservas (condicional) */}
                                {atendimento.tem_reservas && (
                                    <div
                                        className="rounded mb-3 p-3"
                                        style={{ backgroundColor: '#f5f5f5', border: '1px solid #e0e0e0' }}
                                    >
                                        <h5 className="text-danger mb-3">
                                            O cliente possui reservas pendentes. Ao finalizar o atendimento, essas reservas serão canceladas.
                                        </h5>
                                        <h6>Reservas:</h6>
                                        <table className="table table-sm table-hover bg-white rounded">
                                            <thead style={{ backgroundColor: '#0747a6', color: '#fff' }}>
                                                <tr>
                                                    <th>Empreendimento</th>
                                                    <th>Ativo</th>
                                                    <th>Quadra</th>
                                                    <th>Lote</th>
                                                    <th>Validade</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {atendimento.reservas.map((r, idx) => (
                                                    <tr key={idx}>
                                                        <td>{r.nome_familia}</td>
                                                        <td>{r.codigo_ativo}</td>
                                                        <td>{r.mapa1}</td>
                                                        <td>{r.mapa2}</td>
                                                        <td>{formatarData(r.validade)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="mt-3">
                                            <Button variant="warning" onClick={() => setShowModalVisitar(true)} className="mr-2" disabled={loading}>
                                                Visitar Loteamento <FaMapMarkedAlt />
                                            </Button>
                                            <Button variant="warning" onClick={handlePesquisaNaoCompra} className="mr-2">
                                                Estou Ciente, Realizar Pesquisa de Não-Compra <FaFileAlt />
                                            </Button>
                                            <Button variant="danger" onClick={() => setShowModalFinalizar(true)}>
                                                Estou Ciente, Finalizar Atendimento <FaExclamationTriangle />
                                            </Button>
                                            <Button variant="primary" className="float-right" onClick={handleMapaHumanizado}>
                                                Mapa Humanizado <FaBuilding />
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                {/* Botões de Ação */}
                                {!atendimento.tem_reservas && (() => {
                                    const temVendaRealizada = atendimento.pre_venda
                                        && atendimento.pre_venda !== 'venda não realizada'
                                        && atendimento.pre_venda !== '';
                                    return (
                                    <div className="row">
                                        <div className="col-md-12">
                                            {temVendaRealizada && (
                                                <Button variant="success" onClick={() => setShowModalFinalizar(true)} disabled={loading}>
                                                    Finalizar Atendimento <FaSignInAlt />
                                                </Button>
                                            )}
                                            <Button variant="warning" className="ml-2" onClick={() => setShowModalVisitar(true)} disabled={loading}>
                                                Visitar Loteamento <FaMapMarkedAlt />
                                            </Button>
                                            {!temVendaRealizada && (
                                                <Button variant="danger" className="ml-2" onClick={handlePesquisaNaoCompra} disabled={loading}>
                                                    Realizar Pesquisa de Não-Compra <FaFileAlt />
                                                </Button>
                                            )}
                                            <Button variant="primary" className="float-right" onClick={handleMapaHumanizado}>
                                                Mapa Humanizado <FaBuilding />
                                            </Button>
                                        </div>
                                    </div>
                                    );
                                })()}
                            </div>
                        </div>
                    )}

                    {/* PAINEL PESQUISA DE NÃO-COMPRA */}
                    {showPesquisa && (
                        <div className="bg-white rounded my-2 shadow-sm border">
                            <div className="px-3 py-2 rounded-top" style={{ backgroundColor: '#0747a6' }}>
                                <h6 className="mb-0 text-white">Pesquisa de Não-Compra</h6>
                            </div>
                            <div className="p-3">
                                {/* Lista de Motivos */}
                                <Form.Group className="mb-3">
                                    <Form.Label><strong>Motivos</strong></Form.Label>
                                    <Row>
                                        {motivos.map(motivo => (
                                            <Col md={4} key={motivo.codigo}>
                                                <Form.Group className="mb-1">
                                                    <input
                                                        type="checkbox"
                                                        id={`motivo-${motivo.codigo}`}
                                                        checked={motivosSelecionados.includes(motivo.codigo)}
                                                        onChange={() => toggleMotivo(motivo.codigo)}
                                                    />
                                                    <Form.Label
                                                        htmlFor={`motivo-${motivo.codigo}`}
                                                        className="ml-2 mb-0 small"
                                                    >
                                                        {motivo.descricao}
                                                    </Form.Label>
                                                </Form.Group>
                                            </Col>
                                        ))}
                                    </Row>
                                </Form.Group>

                                {/* Sub-motivos dos motivos selecionados */}
                                {motivos.filter(m => motivosSelecionados.includes(m.codigo) && m.sub_motivos && m.sub_motivos.length > 0).length > 0 && (
                                    <Form.Group className="mb-3">
                                        <Form.Label><strong>Detalhamento</strong></Form.Label>
                                        <Row>
                                            {motivos.filter(m => motivosSelecionados.includes(m.codigo) && m.sub_motivos && m.sub_motivos.length > 0).map(motivo => (
                                                motivo.sub_motivos.map(sub => (
                                                    <Col md={6} key={sub.codigo}>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="small mb-1">
                                                                <strong>{motivo.descricao}</strong> - {sub.descricao}:
                                                            </Form.Label>
                                                            <Form.Control
                                                                size="sm"
                                                                value={subMotivosValores[sub.codigo] || ''}
                                                                onChange={(e) => handleSubMotivoChange(sub.codigo, e.target.value)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                ))
                                            ))}
                                        </Row>
                                    </Form.Group>
                                )}

                                {/* Observações */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Observações</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        value={observacoesPesquisa}
                                        onChange={(e) => setObservacoesPesquisa(e.target.value)}
                                    />
                                </Form.Group>

                                {/* Botões */}
                                <div className="row">
                                    <div className="col-md-6 text-center">
                                        <Button variant="danger" block onClick={handleCancelarPesquisa}>
                                            Cancelar
                                        </Button>
                                    </div>
                                    <div className="col-md-6 text-center">
                                        <Button variant="success" block onClick={handleAbrirModalPesquisa} disabled={loading}>
                                            <i className="fa fa-save mr-2"></i>
                                            Finalizar Atendimento
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* MODAIS DE CONFIRMAÇÃO */}

            {/* Modal Iniciar Atendimento */}
            <Modal show={showModalIniciar} onHide={() => setShowModalIniciar(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Início</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Deseja iniciar o atendimento?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalIniciar(false)}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleIniciarAtendimento}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Finalizar Atendimento */}
            <Modal show={showModalFinalizar} onHide={() => setShowModalFinalizar(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Finalização</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Deseja finalizar o atendimento?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalFinalizar(false)}>
                        Cancelar
                    </Button>
                    <Button variant="danger" onClick={() => handleFinalizarAtendimento(false)}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Visitar Loteamento */}
            <Modal show={showModalVisitar} onHide={() => setShowModalVisitar(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Visita ao Loteamento</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Deseja finalizar como visitar loteamento?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalVisitar(false)}>
                        Cancelar
                    </Button>
                    <Button variant="warning" onClick={handleVisitarLoteamento}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Gravar Pesquisa */}
            <Modal show={showModalPesquisa} onHide={() => setShowModalPesquisa(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmar Finalização</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Deseja finalizar o atendimento com a pesquisa de não-compra?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalPesquisa(false)}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleGravarPesquisa}>
                        Confirmar
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DefinirMesaEAtendimento;